import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

export const USER_PROGRAM_ORDER_CREATE_SELL_OTP =
  'EMPLOYEE/USER_PROGRAM_ORDER_CREATE_SELL_OTP'

const apiCall = enhancedMakeFetchAction(
  USER_PROGRAM_ORDER_CREATE_SELL_OTP,
  ({ id, ...payload }) => ({
    endpoint: generateEndpoint({
      host: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/user-programs/${id}/program-orders/sell-otp`
    }),
    method: 'POST',
    body: payload,
    notify: true
  })
)

export default apiCall
